import { OPEN_ERROR_MESSAGE_MODAL, CLOSE_ERROR_MESSAGE_MODAL } from '../constants/actionTypes';

/**
 * Opens the Error Message
 */
export const openErrorMessageModal = () => ({
    type: OPEN_ERROR_MESSAGE_MODAL,
});

/**
 * Closes the Error Message
 */
export const closeErrorMessageModal = () => ({
    type: CLOSE_ERROR_MESSAGE_MODAL,
});
